import { clearCallbacks, getCallback } from "./callbacks";
import { resetStore } from "../store";
import { abortPolling } from '@chegg/one-auth-sdk';
export { cleanup };
function cleanup() {
  getCallback('onClose')();
  clearCallbacks();
  resetStore();
  abortPolling();
}